import { Hero, Features, HowItWorks, CTA, Team } from '@/pages/landing/sections/sections';
import React from 'react';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[var(--surface-ambient)] text-[var(--text-primary)]">
      <Hero />
      <Features />
      <HowItWorks />
      <CTA />
      <Team />
    </div>
  );
}
